export const apiKey = "7d84568bcd5772f65979d42f4330180f";